import React from 'react';
import { View } from 'react-native';

interface SkeletonListProps {
  count?: number;
  gap?: number;
  children: React.ReactNode;
}

export const SkeletonList: React.FC<SkeletonListProps> = React.memo(({
  count = 3,
  gap = 12,
  children,
}) => (
  <View style={{ gap }}>
    {Array.from({ length: count }).map((_, i) => (
      <React.Fragment key={i}>{children}</React.Fragment>
    ))}
  </View>
));

SkeletonList.displayName = 'SkeletonList';
